import { useEffect, useState } from "react";
import { ShieldCheck, Loader2 } from "lucide-react";
import { BigButton, StepTitle } from "./KycShell";
import { Bloqueo } from "./StepDocumento";
import { kycApi } from "../../lib/kycApi";

export const DIDIT_KEY = "inticheck_didit";

const Esperando = ({ onRetry, color }) => (
  <div className="text-center space-y-5 py-8" data-testid="didit-esperando">
    <Loader2 size={48} className="mx-auto animate-spin text-slate-600" />
    <h2 className="font-heading text-2xl font-bold">Estamos recibiendo tu verificación</h2>
    <p className="text-base text-slate-500">Si recién terminaste, espera unos segundos.</p>
    <BigButton color={color} onClick={onRetry} data-testid="didit-reintentar">Revisar de nuevo</BigButton>
  </div>
);

export const StepDidit = ({ brand, session, call, retorno, onDone, onManual, paso }) => {
  const [fase, setFase] = useState(retorno ? "sync" : "inicio");
  const [bloqueo, setBloqueo] = useState(null);

  const sync = async () => {
    setFase("sync");
    for (let i = 0; i < 6; i++) {
      const r = (await call(() => kycApi.diditSync(session)))?.data;
      if (!r) return setFase("espera");
      if (r.bloqueo) return setBloqueo(r.bloqueo);
      if (r.ok) {
        sessionStorage.removeItem(DIDIT_KEY);
        return onDone(r.datos, r.telefono_verificado);
      }
      if (r.manual) return onManual();
      await new Promise((ok) => setTimeout(ok, 3000));
    }
    setFase("espera");
  };
  useEffect(() => {
    if (retorno) sync();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const ir = async () => {
    const r = (await call(() => kycApi.diditIniciar(session)))?.data;
    if (!r) return;
    sessionStorage.setItem(DIDIT_KEY, JSON.stringify(session));
    window.location.assign(r.url);
  };

  if (bloqueo) return <Bloqueo b={bloqueo} />;
  if (fase === "sync") return <Esperando onRetry={sync} color={brand.color} />;
  if (fase === "espera") return <Esperando onRetry={sync} color={brand.color} />;
  return (
    <div className="space-y-5" data-testid="kyc-step-didit">
      <StepTitle paso={paso} title="Verifica tu documento y tu rostro">
        Te llevaremos a Didit, el proveedor de verificación de {brand.nombre}. Allí fotografiarás tu documento y harás una selfie con prueba de vida. Al terminar volverás aquí.
      </StepTitle>
      <p className="flex gap-2 text-base text-slate-600"><ShieldCheck className="shrink-0" /> {brand.nombre} no guarda tu selfie ni tu video.</p>
      <BigButton color={brand.color} onClick={ir} data-testid="didit-ir-button">Continuar a la verificación</BigButton>
    </div>
  );
};
